const emptyGeoJSON = {
  type: 'FeatureCollection',
  features: []
}

export default emptyGeoJSON;